import { ADICIONAR_FILTRO_USUARIO } from '../types'

export default function adicionarFiltroUsuario (filtro) {
  return {
    type: ADICIONAR_FILTRO_USUARIO,
    payload: filtro
  }
}
